import { AbsoluteCenter } from "@chakra-ui/react";
import { AppLoggedOutLayout } from "app/AppLoggedOutLayout";
import { signOut } from "features/auth/AuthUtils";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { LoadingState } from "shared/components/empty/LoadingState";
import { AppConfig } from "shared/config/AppConfig";
import { useEffectOnce } from "shared/hooks/useEffectOnce";
import { rootRoute } from "shared/navigation/Routes";

const logoutPath = rootRoute({}).auth({}).logout({}).$;

export const AuthPage: React.FC = () => {
  const location = useLocation();

  useEffectOnce(() => {
    void (async () => {
      if (AppConfig.subdomains && !AppConfig.subdomains.isAuthOnly) {
        if (location.pathname === logoutPath) {
          await signOut(true);
        }
        const redirectUrl = new URL(
          location.pathname,
          AppConfig.subdomains.authRootUrl.toString(),
        );
        window.location.replace(redirectUrl);
      }
    })();
  });

  if (AppConfig.subdomains?.isSubdomain) {
    return (
      <AppLoggedOutLayout>
        <AbsoluteCenter>
          <LoadingState />
        </AbsoluteCenter>
      </AppLoggedOutLayout>
    );
  }
  return <Outlet />;
};
